import React from 'react';
import { css } from '@emotion/core';

import t from 'react-translate';
import { AngularContext } from 'react-app';
import NvSwitch from 'shared/components/inputs/nv-switch';

type Props = {
  /**
   * Angular expression string
   */
  value: string,
  /**
   * Angular function expression string
   */
  onChange: string,
  dataQa?: string,
  labelText?: string,
  pendoTagName?: string,
};

const AdvancedSettingsSwitch = (props: Props) => {
  const {
    value,
    dataQa,
    onChange,
    labelText,
    pendoTagName,
  } = props;
  const { $scope, injectServices } = React.useContext(AngularContext);
  const [$parse] = injectServices(['$parse']);
  const [switchValue, setSwitchValue] = React.useState($scope.$eval(value));

  React.useEffect(() => {
    $scope.$watch(value, (newValue) => {
      setSwitchValue(newValue);
    });
  }, [$scope, value]);

  const handleSwitchChange = (newValue) => {
    $parse(onChange)($scope, {
      value: newValue,
    });
  };

  const styles = css`
    & > * {
      vertical-align: middle;
    }
  `;

  return (
    <React.Fragment>
      {/* Angular institution page styles class */}
      <div className='switch' css={styles}>
        <NvSwitch
          data-qa={dataQa}
          checked={switchValue}
          onChange={handleSwitchChange}
          pendo-tag-name={pendoTagName}
          enabledLabel={t.SHARED.ENABLED().toUpperCase()}
          disabledLabel={t.SHARED.DISABLED().toUpperCase()}
        />
        {labelText && (
          <span className='ml-2'>{labelText}</span>
        )}
      </div>
    </React.Fragment>
  );
};

export default AdvancedSettingsSwitch;
